'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './Introduction.module.scss'
import { useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import LazyImage from '@/components/common/LazyImage'
import { PortableText } from '@portabletext/react'
import { portableBlockComponents } from '@/utils/portableText'
import { Body } from '@/types/common/Body'

interface IntroductionProps {
    data: DataProps
}

interface DataProps {
    _type: string;
    _ref: string;
    content: Body[] | null;
    borderBottom: boolean;
}

export default function IntroductionComponent({
    data
}: IntroductionProps) {

    return (
        <div className={s.introduction}>
            {data.content && 
                <>
                {data.content.map((textRow: any) => {
                    return(
                        <PortableText
                            key={textRow._key}
                            value={[textRow]}
                            components={portableBlockComponents(data.content)}
                        />
                    )})}
                </>
            }
        </div>
    )
}
